export const RS_METHOD_GET = []
export const RS_METHOD_CALL = []
export const RS_METHOD_WATCH = []
export const RS_METHOD_REF = []

export interface $RS_G {}

export interface $RS_C {}

export interface $RS_W {}

export interface $RS_R {}

export interface $RS extends $RS_G, $RS_C, $RS_W, $RS_R {}
